import React from 'react';
import './BecomeASellerChallengesSection.scss';
import { Typography } from '@mui/material';
import PublicIcon from '@mui/icons-material/Public';
import ScheduleIcon from '@mui/icons-material/Schedule';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import PeopleIcon from '@mui/icons-material/People';
import WarningIcon from '@mui/icons-material/Warning';
import SecurityIcon from '@mui/icons-material/Security';

const BecomeASellerChallengesSection = () => {
  const challenges = [
    {
      id: 1,
      icon: PublicIcon,
      title: "Global Competition Overload",
      description: "Millions of freelancers competing globally makes it nearly impossible to stand out, especially for talented professionals just starting their journey."
    },
    {
      id: 2,
      icon: ScheduleIcon,
      title: "Long Waiting Periods",
      description: "Despite having excellent skills, new freelancers often wait months before getting their first order, leading to frustration and lost opportunities."
    },
    {
      id: 3,
      icon: AttachMoneyIcon,
      title: "Fixed Pricing Limitations",
      description: "Platforms force you to set fixed prices without understanding client needs, leading to undervaluing your work or losing projects to cheaper alternatives."
    },
    {
      id: 4,
      icon: VisibilityOffIcon,
      title: "Lack of Transparency",
      description: "Hidden charges, unclear fee structures, and surprise deductions eat into your hard-earned income without proper disclosure."
    },
    {
      id: 5,
      icon: PeopleIcon,
      title: "High Commission Rates",
      description: "Excessive platform fees (25-40%) significantly reduce your earnings, making it harder to build a sustainable freelancing career."
    },
    {
      id: 6,
      icon: WarningIcon,
      title: "Disorganized Workflow",
      description: "Managing multiple projects becomes chaotic without proper tools, leading to missed deadlines and poor client relationships."
    },
    {
      id: 7,
      icon: SecurityIcon,
      title: "File Security Risks",
      description: "Platforms require sharing original files upfront, leaving freelancers vulnerable to theft when clients copy work and refuse payment approval."
    }
  ];

  return (
    <div className="become-freelancer-challenges">
      <div className="challenges-container">
        {/* Header Section */}
        <div className="challenges-header">
          <Typography variant="h3" className="challenges-title">
            The Freelancing Reality Check
          </Typography>
          <Typography variant="h6" className="challenges-subtitle">
            We understand the real challenges freelancers face. These aren't just statistics - they're the daily struggles that keep talented professionals from reaching their potential.
          </Typography>
        </div>

        {/* Challenges Grid */}
        <div className="challenges-grid">
          {challenges.map((challenge) => {
            const IconComponent = challenge.icon;
            return (
              <div key={challenge.id} className="challenge-card">
                <div className="card-icon">
                  <IconComponent className="icon" />
                </div>
                <div className="card-content">
                  <Typography variant="h6" className="card-title">
                    {challenge.title}
                  </Typography>
                  <Typography variant="body2" className="card-description">
                    {challenge.description}
                  </Typography>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default BecomeASellerChallengesSection;
